import React from 'react';
import PropTypes from 'prop-types';

// components
import { FavoritesItem } from '../../components/global/FavoriteIcons/FavoritesItem';
import { FavoritesProvider } from '../../components/global/FavoriteIcons/FavoritesProvider';

// helpers
import { locations } from '../../utils/tracking/shared/favoritesTracking';
import { LOCATION_PDP } from '../../components/global/TradeFavoritesTooltip/tradeFavoritesTooltipTracking';

export function PdpSharedSidebarFavorites(props) {
    // Todo: Directly pass in userId
    const { isClient, itemId, environment, userId } = props;

    return (
        <FavoritesProvider
            environment={environment}
            location={locations.SIDEBAR}
            disable={!isClient}
            userId={userId}
            itemIds={[itemId]}
            shouldAutoFavorite
        >
            {// eslint-disable-next-line
            ({ props: renderProps }) => (
                <FavoritesItem
                    {...renderProps}
                    itemId={itemId}
                    itemTitle={props.itemTitle}
                    itemImage={props.itemImage}
                    wrapperClass={props.wrapperClass}
                    heartIconWrapperClass={props.heartIconWrapperClass}
                    folderIconWrapperClass={props.folderIconWrapperClass}
                    showTooltipOnFirstClick
                    tooltipTrackingLabel={LOCATION_PDP}
                    type={props.type}
                    isStrokeWidthHeavy={props.isStrokeWidthHeavy}
                />
            )}
        </FavoritesProvider>
    );
}

PdpSharedSidebarFavorites.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    isClient: PropTypes.bool.isRequired,
    wrapperClass: PropTypes.string,
    heartIconWrapperClass: PropTypes.string,
    folderIconWrapperClass: PropTypes.string,
    environment: PropTypes.object.isRequired,
    itemTitle: PropTypes.string,
    itemImage: PropTypes.string,
    type: PropTypes.oneOf(['outline', 'button']),
    isStrokeWidthHeavy: PropTypes.bool,
};
